import page9 from "./Page9.webp";
import page10 from "./Page10.webp";
import page11 from "./Page11.webp";
import page12 from "./Page12.webp";
import page13 from "./Page13.webp";

export const colorPopPages = [page9, page10, page11, page12, page13];
